import isNumber from "lodash/isNumber";

export const formatNumber = (number) => {
  if (!isNumber(number)) {
    return number;
  }
  return number.toLocaleString();
};
